import { UseFormRegisterReturn } from 'react-hook-form';
import { Icon } from '../atoms';
import { ErrorBox } from './ErrorBox';
import { Tag } from './Tag';

type TagButton = {
  label: string;
  value: string;
};

type TagSelectProps = {
  tags: TagButton[];
  selectedTags: string[];
  onSelectionChange: (selectedTags: string[]) => void;
  error?: string;

  register: () => UseFormRegisterReturn<string>;
};

export const TagSelect = (props: TagSelectProps) => {
  const { tags, onSelectionChange, selectedTags, error, register } = props;

  const toggleTag = (tag: string) => {
    const updatedSelection =
      selectedTags.includes(tag) ? selectedTags.filter((t) => t !== tag) : [...selectedTags, tag];

    onSelectionChange(updatedSelection);
  };

  return (
    <div className='flex flex-col gap-4'>
      <div className='flex flex-row gap-4 flex-wrap' {...register()}>
        {tags.map((tag) => (
          <Tag
            size='lg'
            roundedFull={true}
            key={tag.value}
            onClick={() => toggleTag(tag.value)}
            additionalClassNames={`cursor-pointer text-gray-500 select-none ${selectedTags.includes(tag.value) ? 'bg-gray-100' : 'bg-gray-50'}`}
          >
            {tag.label}
          </Tag>
        ))}
      </div>
      {error && (
        <ErrorBox>
          <div className='w-6 flex items-center justify-center'>
            <Icon type='alert-triangle' size='24' />
          </div>
          {error}
        </ErrorBox>
      )}
    </div>
  );
};

export default TagSelect;
